export const dpsBasicCarouselSettings = {
  dots: true,
  infinite: true,
  speed: 300,
  lazyLoad: true,
};